// Server rate limits for internal GraphQL reads (per minute):
//   - Logged-in: 400 requests/minute
//   - Anonymous: 60 requests/minute
// Each navigation fires ~3-5 GraphQL requests, so we apply a 75% safety margin.
export const NAV_RATE_WINDOW_MS = 60_000
export const NAV_RATE_LIMIT_LOGGED_IN = 60 // (400 / 5) * 0.75
export const NAV_RATE_LIMIT_ANON = 9 // (60 / 5) * 0.75

// Minimum ms between navigations to avoid secondary (burst) rate limits.
// Slows to NAV_THROTTLE_MS_SLOW when approaching the rate limit.
export const NAV_THROTTLE_MS = 150
export const NAV_THROTTLE_MS_SLOW = 300

const navTimestamps: number[] = []
const visitedIndices = new Set<number>()
let lastNavTime = 0
let pendingNavIndex: number | null = null

function evictExpired() {
  const cutoff = Date.now() - NAV_RATE_WINDOW_MS
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  while (navTimestamps.length > 0 && navTimestamps[0]! < cutoff) {
    navTimestamps.shift()
  }
}

export function isThrottled(loggedIn: boolean): boolean {
  const window = isApproachingRateLimit(loggedIn) ? NAV_THROTTLE_MS_SLOW : NAV_THROTTLE_MS
  return Date.now() - lastNavTime < window
}

export function isApproachingRateLimit(loggedIn: boolean): boolean {
  evictExpired()
  const limit = loggedIn ? NAV_RATE_LIMIT_LOGGED_IN : NAV_RATE_LIMIT_ANON
  return navTimestamps.length >= limit
}

export function recordNavigation() {
  evictExpired()
  navTimestamps.push(Date.now())
  lastNavTime = Date.now()
}

export function markVisited(index: number) {
  visitedIndices.add(index)
}

export function isVisited(index: number): boolean {
  return visitedIndices.has(index)
}

export function setPendingNavIndex(index: number) {
  pendingNavIndex = index
}

export function consumePendingNavIndex(): number | null {
  const idx = pendingNavIndex
  pendingNavIndex = null
  return idx
}

export function resetNavRateLimit() {
  navTimestamps.length = 0
  visitedIndices.clear()
  lastNavTime = 0
  pendingNavIndex = null
}
